import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'

interface Props {
  score?: number
  horizontal?: boolean
}

const ConformityCard = ({ score, horizontal }: Props) => {
  const i18n = useI18n()

  return (
    <Content horizontal={horizontal}>
      <Card horizontal={horizontal}>
        <ConformityText>{i18n.t('components.conformity.rateGlobal')}</ConformityText>
        <Conformity>{score !== undefined ? `${Math.floor(score)}%` : i18n.t('errors.NC')}</Conformity>
      </Card>

      <Badge horizontal={horizontal}>
        <Icon name="badge" size={68} />
      </Badge>
    </Content>
  )
}

export default ConformityCard

const Content = styled(View)<{ horizontal?: boolean }>`
  flex-direction: ${(props) => (!props.horizontal && props.theme.breakpoint === 'phone' ? 'column' : 'row')};
  align-items: center;
`

const Card = styled(View)<{ horizontal?: boolean }>`
  background-color: ${(props) => props.theme.colors.alertButtonLight};
  border: 1px solid ${(props) => props.theme.colors.accent};
  border-radius: 12px;
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 16)}px
    ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 24)}px;
  align-items: center;
  flex-direction: ${(props) => (!props.horizontal && props.theme.breakpoint === 'phone' ? 'column' : 'row')};
  ${(props) => (props.theme.breakpoint === 'phone' ? 'margin-top: 34px' : 'margin-right: 34px')};
  ${(props) => (props.theme.breakpoint === 'phone' ? 'padding-top: 34px' : 'padding-right: 34px')};
  ${(props) => !!props.horizontal && 'padding-top: 16px'};
`

const ConformityText = styled(Text)`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Caption1 : props.theme.fonts.Subheadline)};
  ${(props) => props.theme.breakpoint === 'phone' && 'text-align: center'};
  color: ${(props) => props.theme.colors.accent};
  max-width: 75px;
`

const Conformity = styled(Text)`
  ${(props) => props.theme.fonts.Title1};
  ${(props) => props.theme.breakpoint !== 'phone' && 'margin: 0px 24px'};
  color: ${(props) => props.theme.colors.accent};
`

const Badge = styled(View)<{ horizontal?: boolean }>`
  position: absolute;
  ${(props) => (props.theme.breakpoint === 'phone' ? 'top: 0px' : 'right: 0px')};
  ${(props) => !!props.horizontal && 'top: 0px; right: 16px;'}
`
